/** ai大赛 */
export const aiCompetition = [
  {
    name: 'getCompetitionList', // 大赛列表
    isMock: false,
  },
  {
    name: 'getCompetitionDetail', //大赛活动详情
    isMock: false,
  },
  {
    name: 'getCompetitionProductDetail', //大赛作品详情
    isMock: false,
  },
  {
    name: 'getUserAllCompetitionResult', // 用户所有大赛获奖作品
    isMock: false,
  },
]
